import {gql} from "@apollo/client";

export const SaveContactFormMutation = gql`
  mutation saveForm($email: String!, $fName: String!, $lName: String!, $phone: String, $message: String!){
    createContactForm(
      input: {
        email: $email,
        fName: $fName,
        lName: $lName,
        phone: $phone,
        message: $message
      }) {
      contactForm {
        id
      }
    }
  }
`
